// 4-button segmented control for switching between UI shells. Lives inside
// Header so it persists across shell changes. Glyphs (◧ ⊕ ⊞ ⊟) make the
// segments scannable at a glance — these are different *views*, not tabs.
import type { Shell } from '../shells/types';
import { SHELL_VALUES } from '../shells/types';

interface Props {
  shell: Shell;
  onChange: (s: Shell) => void;
}

interface SegmentDef {
  value: Shell;
  glyph: string;
  label: string;
  hint: string;
}

const SEGMENTS: Record<Shell, SegmentDef> = {
  classic:   { value: 'classic',   glyph: '◧', label: 'Classic',   hint: 'Chat thread' },
  atlas:     { value: 'atlas',     glyph: '⊕', label: 'Atlas',     hint: 'Map-first' },
  workspace: { value: 'workspace', glyph: '⊞', label: 'Workspace', hint: 'Multi-card canvas' },
  dashboard: { value: 'dashboard', glyph: '⊟', label: 'Dashboard', hint: 'Standing tiles' },
};

export function ShellSwitcher({ shell, onChange }: Props) {
  return (
    <div className="shell-switcher" role="group" aria-label="Choose layout">
      {SHELL_VALUES.map((s) => {
        const def = SEGMENTS[s];
        const active = s === shell;
        return (
          <button
            key={s}
            className={`shell-switcher__btn ${active ? 'shell-switcher__btn--active' : ''}`}
            onClick={() => onChange(s)}
            aria-pressed={active}
            title={def.hint}
          >
            <span className="shell-switcher__glyph" aria-hidden="true">{def.glyph}</span>
            <span className="shell-switcher__label">{def.label}</span>
          </button>
        );
      })}
    </div>
  );
}
